import React, { useState, useEffect } from 'react';
import { UserAuth } from '../../context/AuthContext';
import { useTheme  } from '../../context/ThemeContext';
import { Link, useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGoogle } from '@fortawesome/free-brands-svg-icons';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import temisLight from '../../images/loginLight.png'; 
import temisDark from '../../images/loginDark.png'; 
import './login-signup.css';

const Login = () => {
    const { signIn, user, token, signInWithGooglePopup } = UserAuth();
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const navigate = useNavigate();
    const { isDarkMode, themeClass, toggleTheme } = useTheme();

    useEffect(() => {
        if (user !== null && token !== '') {
            navigate('/account');
        }
    }, [user, token, navigate]);

    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            await signIn(email, password);
        } catch (e) {
            console.error(e.message);
            let message;
            switch (e.code) {
                case 'auth/user-not-found':
                    message = 'Usuario  y/o contraseña inválidos. Por favor, vuelve a intentar.';
                    break;
                case 'auth/wrong-password':
                    message = 'Usuario  y/o contraseña inválidos. Por favor, vuelve a intentar.';
                    break;
                case 'auth/invalid-email':
                    message = 'Email inválido. Por favor ingresa un email válido.';
                    break;
                case 'auth/invalid-credential':
                    message = 'Credenciales inválidas. Por favor verifica tu email y contraseña.';
                    break;
                default:
                    message = 'Ocurrió un error. Por favor intenta nuevamente.';
            }
            setError(message);
        }
    };

    const handleGoogleSignIn = async () => {
        try {
            await signInWithGooglePopup();
            navigate('/account');
        } catch (error) {
            console.error(error);
            setError('No se pudo iniciar sesión con Google');
        }
    };

    // Limpiar error cuando el usuario empiece a escribir
    const handleEmailChange = (e) => {
        setEmail(e.target.value);
        if (error) setError('');
    };

    const handlePasswordChange = (e) => {
        setPassword(e.target.value);
        if (error) setError('');
    };


    return (
        <div className={`signup-container ${themeClass}`}>
            <div className={`topButtons ${themeClass}`}>
                {/* Toggle de Tema */}
                <div className="header-left">
                    <div className="theme-toggle">
                        <span className="colorIconToggle">☼</span>
                        <label className="toggle-switch">
                            <input
                                type="checkbox"
                                checked={isDarkMode}
                                onChange={toggleTheme}
                                className="toggle-input"
                            />
                            <span className={`toggle-slider ${themeClass}`}>
                                <span className={`toggle-knob ${themeClass}`} />
                            </span>
                        </label>
                        <span className="colorIconToggle">☽</span>
                    </div>
                </div>
                <Link to='/' className={`back-button ${themeClass}`}>
                    ⟨ &nbsp;&nbsp; Regresar
                </Link>
            </div>

            <div className="signupcontainer">
                <img 
                    src={isDarkMode ? temisDark : temisLight} 
                    alt="temis" 
                    className="iconT"
                />

                <h1 className={`signup-title ${themeClass}`}>
                    Ingresa a tu cuenta para continuar con tu asesoría legal
                </h1>

                {error && <div className="error-message">{error}</div>}

                <button className={`google-button ${themeClass}`} onClick={handleGoogleSignIn}>
                    <FontAwesomeIcon icon={faGoogle} className="google-icon" />
                    <div className={`google-txt ${themeClass}`}>Continuar con Google</div>
                </button>

                <div className={`divider ${themeClass}`}>
                    <div className={`linea ${themeClass}`}/>
                    o
                    <div className={`linea ${themeClass}`}/>
                </div>

                <form onSubmit={handleSubmit} className="signup-form">
                    <label className="input-label">Correo electrónico</label>
                    <input
                        className={`input-field ${themeClass}`}
                        type='email'
                        value={email}
                        onChange={handleEmailChange}
                        required
                    />

                    <label className="input-label">Contraseña</label>
                    <div style={{ position: 'relative' }}>
                        <input
                            className={`input-field ${themeClass}`}
                            type={showPassword ? 'text' : 'password'}
                            value={password}
                            onChange={handlePasswordChange}
                            required
                            style={{ paddingRight: '40px' }}
                        />
                        <button
                            type="button"
                            onClick={togglePasswordVisibility}
                            style={{
                                position: 'absolute',
                                right: '10px',
                                top: '50%',
                                transform: 'translateY(-50%)',
                                background: 'none',
                                border: 'none',
                                cursor: 'pointer',
                                padding: '5px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center'
                            }}
                            aria-label={showPassword ? 'Ocultar contraseña' : 'Mostrar contraseña'}
                        >
                            <FontAwesomeIcon 
                                icon={showPassword ? faEye : faEyeSlash}
                                style={{ 
                                    fontSize: '18px',
                                    color: isDarkMode ? '#999' : '#666'
                                }}
                            />
                        </button>
                    </div>
                    <Link to='/reset-password' className={`forgot ${themeClass}`}> ¿Olvidaste tu contraseña?</Link>
                  

                    <div className='sigup-b'>
                        <button className={`color-button ${themeClass}`} type='submit'>
                            Iniciar sesión
                        </button>
                    </div>
                </form>

                <div className="footer-text">
                    ¿No tienes una cuenta?{' '}
                    <Link to='/signup2' className="footer-link">Regístrate aquí</Link>
                </div>
            </div>
        </div>
    );
};

export default Login;